<template>
  <v-container fill-height fluid style="height: 100%; padding: 0;">
    <v-layout fill-height row wrap style="height: 100%;">
      <AdminSideBarMenu />
      <v-flex v-if="isSelectedTab('update-company')" class="dashboard-view">
        <v-breadcrumbs>
          <v-breadcrumbs-item :disabled="true">Companies</v-breadcrumbs-item>
          <v-breadcrumbs-item :disabled="true">Update Company</v-breadcrumbs-item>
        </v-breadcrumbs>
        <update-company />
      </v-flex>
      <v-flex v-if="isSelectedTab('add-company')" class="dashboard-view">
        <v-breadcrumbs>
          <v-breadcrumbs-item :disabled="true">Companies</v-breadcrumbs-item>
          <v-breadcrumbs-item :disabled="true">Add Company</v-breadcrumbs-item>
        </v-breadcrumbs>
        <import-company />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import AdminSideBarMenu from './Components/AdminSideBar'
  import UpdateCompany from './Company/UpdateCompany'
  import ImportCompany from './Company/ImportCompany'

  export default {
    components: {
      AdminSideBarMenu,
      UpdateCompany,
      ImportCompany
    },
    methods: {
      isSelectedTab (tabName) {
        const urlSection = this.$route.params.id || 'general-settings'
        return tabName === urlSection
      }
    },
    mounted () {
      const payload = {
        meta: {
          'h1': 'Update Company',
          'title': 'Update Company',
          'description': 'Update Company',
          'keywords': '',
          'requiresAuth': true
        }
      }
      document.title = payload.meta.title
      this.$store.commit('setHeaderInfo', payload)
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// CompanyView.vue?3292ef52